<template>
  <div class="search-list">
    <div
      class="search-item"
      v-for="item of list"
      :key="item.en"
      @click="onSearchItemClick(item)"
    >
      <div class="search-item__header">
        <div class="search-item__title">
          <img
            src="@/assets/colorIcon/ai-search.svg"
            class="search-item__search"
          >
          Search results for <span class="search-item__subTitle">“{{ item.en }}”</span>
        </div>
        <div class="search-item__view">
          View all
        </div>
      </div>
      <div class="search-item__content">
        <div
          class="search-item-thumbnail"
          v-for="product of item.product_list.slice(0, 5)"
          :key="product.offer_id"
        >
          <Image
            class="search-item-thumbnail__image"
            :src="product.image_url"
          />
          <div
            class="search-item-thumbnail__hot"
            v-if="product.month_sold"
          >
            <img
              class="search-item-thumbnail__fire"
              src="@/assets/hot.svg"
            >
            {{ formatSalesVolume(product.month_sold) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { openURLWithChannelQuery, formatSalesVolume } from '@/utils/utils'
import { Image } from '@/components/Image'

defineProps({
  list: {
    type: Array,
    default: () => []
  }
})

const onSearchItemClick = (item) => {
  openURLWithChannelQuery(`/search?keyword=${item.en}&keywordCn=${item.cn}&isAISearched=true`)
}
</script>

<style lang="less" scoped>
.search-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.search-item {
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #EBF1F5;
  cursor: pointer;

  &__header {
    display: flex;
    justify-content: space-between;
  }

  &__title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-family: mon-500;
    font-size: 12px;
    color: #6E717A;
  }

  &__subTitle {
    font-family: mon-600;
    color: #232323;
  }

  &__search {
    width: 14px;
    height: 14px;
  }

  &__view {
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: mon-500;
    font-size: 11px;
    text-decoration: underline;

    &:hover {
      color: var(--link-hover-color);
    }
  }

  &__arrow {
    font-size: 14px;
  }

  &__content {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
  }

  &-thumbnail {
    position: relative;
    border-radius: 4px;
    overflow: hidden;

    &__image {
      display: block;
      width: 96px;
      height: 96px;
      transition: all .2s ease-in-out;

      &:hover {
        transform: scale(1.2);
      }
    }

    &__hot {
      position: absolute;
      right: 4px;
      bottom: 4px;
      display: flex;
      align-items: center;
      gap: 2px;
      padding: 2px 8px 2px 4px;
      backdrop-filter: blur(20px);
      background: rgba(255, 255, 255, 0.8);
      border-radius: 8px;
      font-family: mon-500;
      font-size: 10px;

      > img {
        width: 12px;
        height: 12px;
      }
    }
  }
}
</style>
